import React from 'react';

import { Button } from '../../../../components';
import { Frame, Title, Body } from './Notice.styles';

export type NoticeProps = {
  title: string;
  body: string;
  /** Label of the optional action (already translated). */
  actionLabel?: string;
  onAction?: () => void;
};

/** A whole-tab message in plain words (not set up, no website yet, could not load), with an optional action. */
export const Notice = ({ title, body, actionLabel, onAction }: NoticeProps): React.ReactElement => (
  <Frame role="status">
    <Title text={title} tag="h3" raw />
    <Body text={body} tag="paragraph" raw />
    {actionLabel && onAction ? (
      <Button label={actionLabel} variant="outline" icon="refresh" onClick={onAction} />
    ) : null}
  </Frame>
);

export default Notice;
